/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import ResponsiveTable from "../../components/ResponsiveTable";
import { Button, Icon, message, Modal, Popconfirm, Tooltip } from "antd";
import { Job, OutputType, ProcessType, User } from "../../JmReact";
import moment from "moment";
import GenericModal from "../../components/GenericModal";
import ModalProgress from "../../components/ModalProgress";
import SelectorZBranchList from "../../components/SelectorZBranchList";


class ZBranchClose extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            modalList: null,
            modalDetails: null,
            payItemList: '',
        };

        this.id = 'GENERIC_SELECTOR_BRANCHES';
        this.id_list = 'Z_BRANCH_DOCS_BEFORE_CLOSE';

        this.api = {
            get: 'get_branch_list',
            get_list: 'z_branch_docs_before_close',
            check_orders: 'check_if_isset_open_orders',
            create_numerator: 'z_branch_docs_create_numerator',
            close_z: 'z_branch_docs_close_z',
        }

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericSelector }
        if (props.data[this.id_list] === undefined) props.data[this.id_list] = { dataset: [] }

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.props.dataActions.genericSelectorRefreshDataset(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.get);

        this.sendAPI("get_pay_items_list", "", ob => {
            let payItemList = ob.data ? encodeURIComponent(ob.data.split("\r").map(x => x ? x.split("\f")[1] : "").join(",")) : ""
            this.setState({ payItemList });
        });
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(22044);
    }

    onStart = (record) => {
        this.sendAPI(this.api.get_list, { _branch: record.code }, ob => {
            if (ob.data) {
                let dataset = []
                const checkIfAfter = (dt1, dt2) => moment(dt1, 'YYYY-MM-DD HH:mm:ss').isAfter(moment(dt2, 'YYYY-MM-DD HH:mm:ss'))
                ob.data.split("\r").forEach(x => {
                    const [_POSID, _POSName, _TypeID, _TypeName, _minTimestamp, _maxTimestamp, _minNumber, _maxNumber] = x.split("\f")
                    let findInDataset = dataset.findIndex(y => y.id == _POSID)
                    if (findInDataset > -1) {
                        dataset[findInDataset] = {
                            ...dataset[findInDataset],
                            types: [...dataset[findInDataset].types, { _TypeID, _TypeName, _minTimestamp, _maxTimestamp, _minNumber, _maxNumber }],
                            min: checkIfAfter(dataset[findInDataset].min, _minTimestamp) ? _minTimestamp : dataset[findInDataset].min,
                            max: checkIfAfter(_maxTimestamp, dataset[findInDataset].max) ? _maxTimestamp : dataset[findInDataset].max
                        }
                    } else {
                        dataset = [
                            ...dataset,
                            {
                                id: _POSID,
                                name: _POSName,
                                types: [{ _TypeID, _TypeName, _minTimestamp, _maxTimestamp, _minNumber, _maxNumber }],
                                min: _minTimestamp,
                                max: _maxTimestamp
                            }
                        ]
                    }
                })
                this.setState({ modalList: record }, () => { this.props.dataActions.setJson(this.id_list, { dataset }) })
            } else {
                message.error(this.getText(22047))
            }
        })
    }

    checkIfIssetOrders = (_branch) => {
        const onOk = () => { this.getNewZBranchNumerator(_branch) }
        this.sendAPI(this.api.check_orders, { _branch }, ob => {
            if (ob.data > 0) {
                Modal.confirm({
                    content: (<h2 dir="rtl">{this.getText(22060)}<br />{this.getText(22061)}</h2>),
                    iconType: 'exclamation-circle',
                    okText: this.getText(22062),
                    cancelText: this.getText(22063),
                    onOk,
                    onCancel() { },
                })
            } else {
                onOk()
            }
        })
    }

    getNewZBranchNumerator = (_branch) => {
        this.sendAPI(this.api.create_numerator, { _branch }, ob => {
            if (ob.data) this.closeZBranch(ob.data, this.props.data[this.id_list].dataset)
        })
    }

    closeZBranch = (_numerator, _list) => {
        const { modalList } = this.state
        if (_list.length) {
            const { id, name, types } = _list[0]
            let countAll = this.props.data[this.id_list].dataset.length
            this.setState({
                modalProgressView: {
                    percent: ((countAll - _list.length) / countAll) * 100,
                    status: "active",
                    message: (<><h2>{this.getText(22066)} {modalList.name} {this.getText(22067)} {name}</h2><h2>{this.getText(22068)}</h2></>),
                }
            }, () => {
                let dataSend = "_branch\f_numerator\f_pos\f_type\f_fromNum\f_toNum\f_fromDatetime\f_toDatetime\r"
                    + types.map(x => {
                        return modalList.code + "\f"
                            + _numerator + "\f"
                            + id + "\f"
                            + x._TypeID + "\f"
                            + x._minNumber + "\f"
                            + x._maxNumber + "\f"
                            + x._minTimestamp + "\f"
                            + x._maxTimestamp
                    }).join("\r")
                this.sendAPI(this.api.close_z, dataSend, () => {
                    this.closeZBranch(_numerator, _list.slice(1))
                })
            })
        } else {

            let branchList = modalList.code
            let dateFrom = null;
            let dateTo = null;
            this.props.data[this.id_list].dataset.forEach(x => {
                let min = moment(x.min, 'YYYY-MM-DD HH:mm:ss')
                let max = moment(x.max, 'YYYY-MM-DD HH:mm:ss')
                if (!dateFrom || moment(dateFrom, 'YYYY-MM-DD').isAfter(min)) dateFrom = min.format("YYYY-MM-DD")
                if (!dateTo || max.isAfter(moment(dateTo, 'YYYY-MM-DD'))) dateTo = max.format("YYYY-MM-DD")
            })

            this.props.ActionQueue.addToQueue({
                action: this.props.dataActions.generateReport,
                args: [this.props.user.companyCode, this.props.user.token, {
                    dateFrom,
                    dateTo,
                    branchList,
                    compDetaild: 1,
                    taxesView: 1,
                    centralType: 8,
                    payTypeList: '',
                    payItemList: this.state.payItemList,
                    payItemsSumType: '1',
                    orderSuppliers: '',
                    zNumber: _numerator,
                    reportName: "reports/Report80PaymentsAnalysisOneBranch.pdf",
                    REPORT_LOCALE: this.getText(101),
                    PosId: 999,
                    addHours: '00:00:00',
                }]
            });
            this.setState({
                modalList: null,
                modalProgressView: null
            }, () => {
                message.success(this.getText(22069))
            })
        }
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    render() {
        let gt = this.getText;

        const formatDatetime = t => t ? moment(t).format("HH:mm:ss DD/MM/YYYY") : ""

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
            width: 500,
            margin: "auto"
        };

        return (<div style={divStyle}>
            <ResponsiveTable
                dataSource={this.props.data[this.id].dataset}
                title={gt(22044)}
                columns={[
                    { title: gt(22045), key: "name", dataIndex: "name", width: "70%", render: t => t },
                    { title: "", width: "15%", render: (t, r) => (<Button onClick={() => { this.onStart(r) }}>{gt(22046)}</Button>) },
                    { title: "", width: "15%", render: (t, r) => (<Button onClick={() => { this.setState({ visibleZBranchList: r.code }) }}>{gt(22264)}</Button>) },
                ]}
            />
            <GenericModal
                visible={this.state.modalList != null}
                onCancel={() => { this.setState({ modalList: null }) }}
                title={this.state.modalList ? `${this.state.modalList.code} - ${this.state.modalList.name}` : ""}
                width={800}
                footer={[
                    <Button style={{ marginLeft: 5 }} onClick={() => { this.setState({ modalList: null }) }}>{gt(22055)}</Button>,
                    <Popconfirm
                        title={`${gt(22057)} ${this.state.modalList?.name}?`}
                        okText={gt(22058)}
                        cancelText={gt(22059)}
                        onConfirm={() => { this.checkIfIssetOrders(this.state.modalList?.code) }} >
                        <Button type="primary">{gt(22056)}</Button>
                    </Popconfirm>
                ]}
            >
                <ResponsiveTable
                    tableOnly
                    dataSource={this.props.data[this.id_list].dataset}
                    columns={[
                        { title: gt(22048), key: "id", dataIndex: "id", width: "10%", render: t => t },
                        { title: gt(22049), key: "name", dataIndex: "name", width: "30%", render: t => t },
                        { title: gt(22050), key: "min", dataIndex: "min", width: "25%", render: formatDatetime },
                        { title: gt(22051), key: "max", dataIndex: "max", width: "25%", render: formatDatetime },
                        { title: "", key: "types", dataIndex: "types", width: "10%", render: (t, r) => (<Tooltip title={gt(22052)}><Icon type="table" onClick={() => { this.setState({ modalDetails: r }) }} /></Tooltip>) },
                    ]}
                />
            </GenericModal>
            <GenericModal
                visible={this.state.modalDetails != null}
                onCancel={() => { this.setState({ modalDetails: null }) }}
                title={this.state.modalDetails ? `${this.state.modalDetails.id} - ${this.state.modalDetails.name}` : ""}
                width={700}
            >
                <ResponsiveTable
                    tableOnly
                    dataSource={this.state.modalDetails?.types ?? []}
                    columns={[
                        { title: gt(22053), key: "_TypeID", dataIndex: "_TypeID", width: "12%", render: t => t },
                        { title: gt(22054), key: "_TypeName", dataIndex: "_TypeName", width: "36%", render: t => t },
                        { title: gt(22050), key: "_minTimestamp", dataIndex: "_minTimestamp", width: "26%", render: formatDatetime },
                        { title: gt(22051), key: "_maxTimestamp", dataIndex: "_maxTimestamp", width: "26%", render: formatDatetime },
                    ]}
                />
            </GenericModal>
            <SelectorZBranchList
                {...this.props}
                isModalOnly
                visible={this.state.visibleZBranchList != null}
                onCancel={() => { this.setState({ visibleZBranchList: null }) }}
                btnText={gt(22265)}
                filters={{ zNumber: "", branchId: this.state.visibleZBranchList }}
                onChange={obj => {
                    let params = {
                        zNumber: obj.zNumber,
                        dateFrom: obj.StartDate,
                        dateTo: obj.EndDate,
                        branchList: obj.branchList,
                        compDetaild: 1,
                        taxesView: 1,
                        centralType: 8,
                        payTypeList: '',
                        payItemList: this.state.payItemList,
                        payItemsSumType: '1',
                        orderSuppliers: '',
                        reportName: "reports/Report80PaymentsAnalysisOneBranch.pdf",
                        PosId: 999,
                        addHours: '00:00:00',
                    };
                    this.props.ActionQueue.addToQueue({ action: this.props.dataActions.generateReport, args: [this.props.user.companyCode, this.props.user.token, params] });
                }} />
            {this.state.modalProgressView != null ?
                <ModalProgress
                    {...this.props}
                    {...this.state.modalProgressView}
                    toggle={true}
                    handleCancel={() => { this.setState({ modalProgressView: null, modalList: null }) }}
                    handleRefrash={() => { }}
                    handleIgnore={() => { }}
                    title={""}
                    width={800}
                    type={"exception"}
                />
                : ""}
        </div>)
    }

}

export default ZBranchClose;